import { motion } from 'framer-motion'
import { ArrowUpRight } from 'lucide-react'
import SectionHeader from './SectionHeader'
import { projects } from '../data/projects'

const Projects = () => {
  return (
    <section id="projects" className="section-shell py-20 md:py-24">
      <SectionHeader
        kicker="Projects"
        title="Selected projects presented as academic case studies."
        text="Each project highlights a problem, a technical solution, and the larger learning outcome behind the work."
      />

      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        {projects.map((project, index) => (
          <motion.article
            key={project.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: index * 0.06 }}
            className="card flex flex-col p-6 transition hover:-translate-y-1 hover:border-academic-blue md:p-8"
          >
            <div className="flex-1">
              <h3 className="text-2xl font-semibold tracking-tight text-academic-text">{project.title}</h3>
              <p className="mt-4 leading-7 text-academic-muted">{project.description}</p>

              <div className="mt-6 grid gap-4">
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.18em] text-academic-blue">Problem</p>
                  <p className="mt-2 leading-7 text-academic-muted">{project.problem}</p>
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.18em] text-academic-blue">Solution</p>
                  <p className="mt-2 leading-7 text-academic-muted">{project.solution}</p>
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.18em] text-academic-blue">Impact</p>
                  <p className="mt-2 leading-7 text-academic-muted">{project.impact}</p>
                </div>
              </div>

              <div className="mt-6 flex flex-wrap gap-2">
                {project.technologies.map((tech) => (
                  <span key={tech} className="rounded-full bg-academic-soft px-3 py-1 text-xs font-semibold text-academic-blue">
                    {tech}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a href={project.links.github} className="secondary-button px-4 py-2">
                GitHub <ArrowUpRight className="ml-2" size={15} />
              </a>
              <a href={project.links.demo} className="secondary-button px-4 py-2">
                Demo <ArrowUpRight className="ml-2" size={15} />
              </a>
              <a href={project.links.caseStudy} className="primary-button px-4 py-2">
                Case Study <ArrowUpRight className="ml-2" size={15} />
              </a>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  )
}

export default Projects
